module.exports = __webpack_public_path__ + "static/img/fruitages.7e26754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fruitages.png
// module id = O0XW
// module chunks = 12